import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { AdminRouter } from "./router";
import { AuthProvider, SiteProvider, LanguageProvider, ZoomProvider, DashTabProvider } from "./contexts";
import { CompanyProvider } from "./contexts/CompanyContext";
import { ResetPasswordForm } from "./components/Admin/Auth";

export default function App() {

  
  return (
    <AuthProvider>
      <CompanyProvider>
      <SiteProvider>
      <LanguageProvider>
      <ZoomProvider>
      <DashTabProvider>
      <BrowserRouter>
        {/* <WebRouter /> */}
        <AdminRouter />
          {/* <Route path="/reset/:token" element={<ResetPasswordForm />} /> */}
      </BrowserRouter>
      </DashTabProvider>
      </ZoomProvider>
      </LanguageProvider>
       </SiteProvider>
       </CompanyProvider>
    </AuthProvider>
  );
}